import React, { useState, useEffect } from 'react';



const rawHTML = `
<!DOCTYPE html>
<html>

<head>
	<title></title>
	<meta content="summary_large_image" name="twitter:card" />
	<meta content="website" property="og:type" />
	<meta content="" property="og:description" />
	<meta content="https://v1sjp8jkro.preview-postedstuff.com/V2-Le0t-NyNd-fgRY-4puL/" property="og:url" />
	<meta content="https://pro-bee-beepro-thumbnail.getbee.io/messages/907814/892129/1812946/9106986_large.jpg" property="og:image" />
	<meta content="" property="og:title" />
	<meta content="" name="description" />
	<meta charset="utf-8" />
	<meta content="width=device-width" name="viewport" />
	<style>
		.bee-row,
		.bee-row-content {
			position: relative
		}

		.bee-row-3,
		.bee-row-3 .bee-row-content {
			background-color: #000
		}

		body {
			background-color: #fff;
			color: #000;
			font-family: Arial, Helvetica, sans-serif
		}

		.bee-row-3 .bee-col-1 .bee-block-1 a,
		a {
			color: #8a3c90
		}

		* {
			box-sizing: border-box
		}

		body,
		h1,
		p {
			margin: 0
		}

		.bee-row-content {
			max-width: 1280px;
			margin: 0 auto;
			display: flex
		}

		.bee-row-content .bee-col-w12 {
			flex-basis: 100%
		}

		.bee-icon .bee-icon-label-right a {
			text-decoration: none
		}

		.bee-image {
			overflow: auto
		}

		.bee-image .bee-center {
			margin: 0 auto
		}

		.bee-row-1 .bee-col-1 .bee-block-1 {
			width: 100%
		}

		.bee-row-1 .bee-row-content,
		.bee-row-2 .bee-row-content,
		.bee-row-3 .bee-row-content {
			border-radius: 0;
			background-repeat: no-repeat;
			color: #000
		}

		.bee-icon {
			display: inline-block;
			vertical-align: middle
		}

		.bee-icon .bee-content {
			display: flex;
			align-items: center
		}

		.bee-image img {
			display: block;
			width: 100%
		}

		.bee-paragraph {
			overflow-wrap: anywhere
		}

		.bee-row-1,
		.bee-row-2,
		.bee-row-4 {
			background-repeat: no-repeat
		}

		.bee-row-1 .bee-col-1,
		.bee-row-2 .bee-col-1,
		.bee-row-3 .bee-col-1,
		.bee-row-4 .bee-col-1 {
			padding-bottom: 5px;
			padding-top: 5px
		}

		.bee-row-2 .bee-col-1 .bee-block-1 {
			padding: 10px;
			text-align: center;
			width: 100%
		}

		.bee-row-2 .bee-col-1 .bee-block-2,
		.bee-row-3 .bee-col-1 .bee-block-1 {
			padding: 10px
		}

		.bee-row-3 {
			background-repeat: no-repeat
		}

		.bee-row-4 .bee-row-content {
			background-repeat: no-repeat;
			color: #000
		}

		.bee-row-4 .bee-col-1 .bee-block-1 {
			color: #9d9d9d;
			font-family: inherit;
			font-size: 15px;
			padding-bottom: 5px;
			padding-top: 5px;
			text-align: center
		}

		.bee-row-2 .bee-col-1 .bee-block-2,
		.bee-row-3 .bee-col-1 .bee-block-1 {
			direction: ltr;
			font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
			font-weight: 400;
			letter-spacing: 0
		}

		.bee-row-3 .bee-col-1 .bee-block-1 {
			color: #fff;
			font-size: 16px;
			line-height: 150%;
			text-align: left
		}

		.bee-row-2 .bee-col-1 .bee-block-2 p:not(:last-child),
		.bee-row-3 .bee-col-1 .bee-block-1 p:not(:last-child) {
			margin-bottom: 4px
		}

		.bee-row-4 .bee-col-1 .bee-block-1 .bee-icon-image {
			padding: 5px 6px 5px 5px
		}

		.bee-row-4 .bee-col-1 .bee-block-1 .bee-icon:not(.bee-icon-first) .bee-content {
			margin-left: 0
		}

		.bee-row-4 .bee-col-1 .bee-block-1 .bee-icon::not(.bee-icon-last) .bee-content {
			margin-right: 0
		}

		.bee-row-2 .bee-col-1 .bee-block-2 {
			color: #101112;
			font-size: 13px;
			line-height: 120%;
			text-align: left
		}

		.bee-row-2 .bee-col-1 .bee-block-2 a {
			color: #3e6497
		}

		@media (max-width:768px) {
			.bee-row-content:not(.no_stack) {
				display: block
			}

			.bee-row-1 .bee-col-1 .bee-block-1 img {
				float: none !important;
				margin: 0 auto !important
			}

			.bee-row-3 .bee-col-1 .bee-block-1 {
				padding: 5px 25px !important;
				font-size: 11px !important
			}

			.bee-row-2 .bee-col-1 .bee-block-1 {
				text-align: center !important
			}

			.bee-row-2 .bee-col-1 .bee-block-1 h1 {
				font-size: 16px !important;
				text-align: center !important
			}

			.bee-row-2 .bee-col-1 .bee-block-2 {
				padding: 10px 20px !important;
				font-size: 13px !important
			}
		}
	</style>
</head>

<body>
	<div class="bee-page-container">
		<div class="bee-row bee-row-1">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-image"><img alt="" class="bee-center bee-fixedwidth" src="https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/907814_892129/image-removebg-preview%20%281%29.png" style="max-width:256px;" /></div>
				</div>
			</div>
		</div>
		<div class="bee-row bee-row-2">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-heading">
						<h1 style="color:#101112;direction:ltr;font-family:Arial, 'Helvetica Neue', Helvetica, sans-serif;font-size:38px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:left;margin-top:0;margin-bottom:0;"><span class="tinyMce-placeholder">Uniserved Tech Solutions Pvt. Ltd Terms of Service</span> </h1>
					</div>
					<div class="bee-block bee-block-2 bee-paragraph">
						<p><strong>Uniserved Tech Solutions Pvt Ltd. Privacy Policy</strong></p>
						<p>Uniserved recognizes the importance of maintaining your privacy. We value your privacy and appreciate your trust in us. This Policy describes how we treat user information we collect on http://uniserved.com and other offline sources. This Privacy Policy applies to current and former visitors to our website and to our online customers. By visiting and/or using our website, you agree to this Privacy Policy.</p>
						<p>Uniserved and <a href="https://uniserved.com/" rel="noopener" style="text-decoration: underline;" target="_blank">http://uniserved.com</a> is a property of Uniserved Tech Solutions Private Limited, an Indian Company registered under the Companies Act, 2013 having its registered office at 317 - Platinum TechnoPark, Sector 30A, Vashi, Navi Mumbai, 400703, Maharastra, India.</p>
						<p><br /><strong>Information we collect</strong></p>
						<p><strong>Contact information.</strong> We might collect your name, email, mobile number, phone number, street, city, state, pincode, country and ip address.</p>
						<p><strong>Payment and billing information.</strong> We might collect your billing name, billing address and payment method when you buy a ticket. We NEVER collect your credit card number or credit card expiry date or other details pertaining to your credit card on our website.</p>
						<p><strong>Information you post.</strong> We collect information you post in a public space on our website or on a third-party social media site belonging to Uniserved or http://uniserved.com/.</p>
						<p><strong>Demographic information.</strong> We may collect demographic information about you or any other information provided by your during the use of our website. We might collect this as a part of a survey also.</p>
						<p><strong>Other information.</strong> If you use our website, we may collect information about your IP address and the browser you're using. We might look at what site you came from, duration of time spent on our website, pages accessed or what site you visit when you leave us. We might also collect the type of mobile device you are using, or the version of the operating system your computer or device is running.</p>
						<p><strong>We collect information in different ways.</strong></p>
						<p> </p>
						<p><strong>We collect information directly from you.</strong> </p>
						<p>We collect information directly from you when you register or fill any form or survey on the website. We also collect information if you post a comment on our websites or ask us a question through phone or email.</p>
						<p><strong>We collect information from you passively.</strong> </p>
						<p>We use tracking tools like Google Analytics, Google Webmaster, browser cookies and web beacons for collecting information about your usage of our website.</p>
						<p><strong>We get information about you from third parties.</strong> </p>
						<p>For example, if you use an integrated social media feature on our websites. The third-party social media site will give us certain information about you. This could include your name and email address.</p>
						<p><br /><strong>Use of your personal information</strong></p>
						<p><strong>We use information to contact you:</strong> </p>
						<p>We might use the information you provide to contact you for confirmation of a purchase on our website or for other promotional purposes.</p>
						<p><strong>We use information to respond to your requests or questions.</strong></p>
						<p>We might use your information to confirm your registration for an event or contest.</p>
						<p><strong>We use information to improve our products and services.</strong> </p>
						<p>We might use your information to customize your experience with us. This could include displaying content based upon your preferences.</p>
						<p><strong>We use information to look at site trends and customer interests.</strong> </p>
						<p>We may use your information to make our website and products better. We may combine information we get from you with information about you we get from third parties.</p>
						<p><strong>We use information for security purposes.</strong></p>
						<p>We may use information to protect our company, our customers, or our websites.</p>
						<p><strong>We use information for marketing purposes.</strong> </p>
						<p>We might send you information about special promotions or offers. We might also tell you about new features or products. These might be our own offers or products, or third-party offers or products we think you might find interesting. Or, for example, if you buy any services from us we'll enroll you in our newsletter.</p>
						<p><strong>We use information to send you transactional communications.</strong></p>
						<p>We might send you emails or SMS about your account or your booked tickets.</p>
						<p>We use information as otherwise permitted by law.</p>
						<p><br /><span style="color: #000000;"><strong>Sharing of information with third-parties</strong></span></p>
						<p><strong>We will share information with third parties who perform services on our behalf.</strong> </p>
						<p>We share information with partners who help us manage our online registration process or payment processors or transactional message processors. Some partners may be located outside of India.</p>
						<p><strong>We will share information with our business partners.</strong> </p>
						<p>This includes a third party who provide or sponsor an event, or who operates a venue where we hold events. Our partners use the information we give them as described in their privacy policies.</p>
						<p><strong>We may share information if we think we have to in order to comply with the law or to protect ourselves.</strong> </p>
						<p>We will share information to respond to a court order or subpoena. We may also share it if a government agency or investigatory body requests. Or, we might also share information when we are investigating potential fraud.</p>
						<p><strong>We may share information with any successor to all or part of our business.</strong></p>
						<p> For example, if part of our business is sold we may give our customer list as part of that transaction.</p>
						<p><strong>We may share your information for reasons not described in this policy.</strong> </p>
						<p>We will tell you before we do this.</p>
						<p><strong>Email Opt-Out</strong></p>
						<p><strong>You can opt out of receiving our marketing emails.</strong></p>
						<p>To stop receiving our promotional emails, please click on the Unsubscribe links included in the emails.</p>
						<p><br /><strong>Third party sites</strong></p>
						<p>If you click on one of the links to third party websites, you may be taken to websites we do not control. This policy does not apply to the privacy practices of those websites. Read the privacy policy of other websites carefully. We are not responsible for these third party sites.</p>
						<p><br /><strong>Grievance Officer</strong></p>
						<p>In accordance with Information Technology Act 2000 and rules made there under, the name and contact details of the Grievance Officer are provided below:</p>
						<p>Mr. Abhijit Kshirsagar</p>
						<p>317 - Platinum Techno Park,</p>
						<p>Sector 30A, Vashi,</p>
						<p>Navi Mumbai, 400703, Maharastra, India.</p>
						<p><strong>Email</strong>: grievances@uniserved.com</p>
						<p>If you have any questions about this Policy or other privacy concerns, you can also email us at privacy@uniserved.com</p>
						<p><br /><strong>Updates to this policy</strong></p>
						<p>This Privacy Policy was last updated on 10.09.2019. From time to time we may change our privacy practices. We will notify you of any material changes to this policy as required by law. We will also post an updated copy on our website. Please check our site periodically for updates.</p>
						<p><br /><strong>Jurisdiction</strong></p>
						<p>If you choose to visit the website, your visit and any dispute over privacy is subject to this Policy and the website's terms of use. In addition to the foregoing, any disputes arising under this Policy shall be governed by the laws of India.</p>
					</div>
				</div>
			</div>
		</div>
		<div class="bee-row bee-row-3">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-paragraph">
						<p>UNISERVED</p>
						<p>We are a Technology Infrastructure platform which uses Enterprise Crowdsourcing to ensure you have the skilled resources where you need them at the right price.</p>
						<p>Helping drive the vision of a Digital India, one project at a time!</p>
						<p> </p>
						<p><span style="color: #434854;">© Copyright 2019 Uniserved Tech Solutions Pvt Ltd (A Savex Group Company)</span></p>
					</div>
				</div>
			</div>
		</div>
</body>

</html>
`;

const PrivacyPolicy = () => {
	return (
		// <div style={container}>
			<div dangerouslySetInnerHTML={{ __html: rawHTML }} style={{overflowY:'scroll', maxHeight:"100%"}}></div>
		// </div>
	);
};

export default PrivacyPolicy;

